import { Box, CircularProgress, Icon, useTheme } from "@mui/material";
import clientIconDark from "../../../assets/icons/loginEmpresaLogoDark.png";
import clientIcon from "../../../assets/icons/loginEmpresaLogoWhite.png";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import apiCliente from "../../../services/apiCliente";
const styles = {
	box: {
		m: 1,
		width: "100%",
		height: "70vh",
		position: "relative",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	icon: {
		width: "fit-content",
		height: "fit-content",
		margin: 2,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	img: {
		width: 80,
		height: "auto",
	},
	circularProgress: {
		color: "primary",
		position: "absolute",
		zIndex: 1,
	},
};

// Verifica se o usuário é um administrador
function checkAdm() {
	let result = JSON.parse(localStorage.getItem("userCliente"));

	// Verifica se a propriedade rlPermissoesUsuario existe e é um array
	if (Array.isArray(result?.usuarioCliente?.RlPermissoesUsuarioCliente)) {
		// Itera sobre o array para verificar se algum objeto contém a propriedade codigoPermissao com valor "ADM"
		for (let permissao of result?.usuarioCliente?.RlPermissoesUsuarioCliente) {
			if (permissao?.permissao?.codigoPermissao?.toUpperCase() === "ADM") {
				return true;
			}
		}
		return false;
	}
}

export default function ProtectedRoute({ children }) {
	const [admChecked, setAdmChecked] = useState(null);
	const theme = useTheme();

	useEffect(() => {
		//setAdmChecked(checkAdm());

		const admValidate = async () => {
			try {
				await apiCliente.get("/cliente/checkAdmPermission");
				setAdmChecked(true);
			} catch (error) {
				setAdmChecked(false);
			}
		};
		admValidate();
	}, []);

	if (admChecked === null) {
		return (
			<Box sx={styles.box}>
				<CircularProgress
					size={100}
					sx={styles.circularProgress}
					thickness={2.5}
				/>
			</Box>
		);
	}

	return admChecked ? children : <Navigate to="/resumo" />;
}
